import { termsOfUse } from './markdownLinks'

export const config = {
  links: {
    getting_started:
      'https://scpca.readthedocs.io/en/stable/getting_started.html',
    frequently_asked_questions:
      'https://scpca.readthedocs.io/en/stable/faq.html',
    what_are_merged_objects:
      'https://scpca.readthedocs.io/en/stable/merged_objects.html',
    what_copy_link:
      'https://scpca.readthedocs.io/en/stable/faq.html#what-does-the-copy-download-link-button-do',
    what_downloading:
      'https://scpca.readthedocs.io/en/stable/download_files.html',
    what_downloading_metadata:
      'https://scpca.readthedocs.io/en/stable/download_files.html#metadata',
    what_downloading_project:
      'https://scpca.readthedocs.io/en/stable/download_files.html#download-folder-structure-for-project-downloads',
    what_downloading_sample:
      'https://scpca.readthedocs.io/en/stable/download_files.html#download-folder-structure-for-individual-sample-downloads',
    what_downloading_spatial:
      'https://scpca.readthedocs.io/en/stable/download_files.html#spatial-transcriptomics-libraries',
    what_downloading_multiplexed:
      'https://scpca.readthedocs.io/en/stable/download_files.html#multiplexed-sample-libraries',
    whatPortalWide:
      'https://scpca.readthedocs.io/en/stable/download_files.html#portal-wide-downloads',
    whatDownloadingPortalWideMetadata:
      'https://scpca.readthedocs.io/en/stable/download_files.html#metadata-only-downloads',
    whatDownloadingPortalWideSCE:
      'https://scpca.readthedocs.io/en/stable/download_files.html#singlecellexperiment-portal-wide-download-structure',
    whatDownloadingPortalWideSCEMerged:
      'https://scpca.readthedocs.io/en/stable/download_files.html#portal-wide-download-structure-for-merged-singlecellexperiment-objects',
    whatDownloadingPortalWideAnndata:
      'https://scpca.readthedocs.io/en/stable/download_files.html#anndata-portal-wide-download-structure',
    whatDownloadingPortalWideAnndataMerged:
      'https://scpca.readthedocs.io/en/stable/download_files.html#portal-wide-download-structure-for-merged-anndata-objects',
    whatDownloadingPortalWideSpatial:
      'https://scpca.readthedocs.io/en/stable/download_files.html#spatial-portal-wide-download-structure',
    whatDownloadingProjectMetadata:
      'https://scpca.readthedocs.io/en/stable/download_files.html#metadata',
    whatDownloadingProjectSCE:
      'https://scpca.readthedocs.io/en/stable/download_files.html#download-folder-structure-for-singlecellexperiment-project-downloads',
    whatDownloadingProjectSCEMerged:
      'https://scpca.readthedocs.io/en/stable/download_files.html#download-folder-structure-for-singlecellexperiment-merged-downloads',
    whatDownloadingProjectAnndata:
      'https://scpca.readthedocs.io/en/stable/download_files.html#download-folder-structure-for-anndata-project-downloads',
    whatDownloadingProjectAnndataMerged:
      'https://scpca.readthedocs.io/en/stable/download_files.html#download-folder-structure-for-anndata-merged-downloads',
    whatDownloadingProjectSpatial:
      'https://scpca.readthedocs.io/en/stable/download_files.html#spatial-transcriptomics-libraries',
    what_est_demux_cell:
      'https://scpca.readthedocs.io/en/stable/faq.html#what-are-estimated-demux-cell-counts',
    what_review_dataset:
      'https://scpca.readthedocs.io/en/stable/faq.html#why-did-project-options-change-when-i-appended-samples-to-my-dataset',
    when_downloading_merged_objects:
      'https://scpca.readthedocs.io/en/stable/faq.html#when-should-i-download-a-project-as-a-merged-object',
    which_projects_are_merged_objects:
      'https://scpca.readthedocs.io/en/stable/faq.html#which-projects-can-i-download-as-merged-objects',
    which_samples_can_download_as_anndata:
      'https://scpca.readthedocs.io/en/stable/faq.html#which-samples-can-i-download-as-anndata-objects',
    why_changing_merged_project:
      'https://scpca.readthedocs.io/en/stable/faq.html#why-can-t-i-merge-a-subset-of-samples-from-a-project',
    how_processed:
      'https://scpca.readthedocs.io/en/stable/processing_information.html',
    how_processed_multiplexed:
      'https://scpca.readthedocs.io/en/stable/processing_information.html#multiplexed-libraries',
    donate: 'https://www.ccdatalab.org/donate-link',
    grants_program: 'https://www.alexslemonade.org/researchers-reviewers',
    help: 'https://scpca.readthedocs.io',
    contribute_pdf: 'contributing-guidelines.pdf',
    contribute_hsform: 'https://share.hsforms.com/1V1loS-_hTMi3-_Lz107AcA336z0',
    contribute_interest_hsform:
      'https://share.hsforms.com/1Fs_Z94OzS7abnh5qEieOTA336z0',
    recruitment_hsform:
      'https://share.hsforms.com/19if2XeF2Rl2YkWxppHW-HQ336z0',
    alsfTwitter: 'https://twitter.com/alexslemonade',
    alsfFacebook: 'https://www.facebook.com/alexslemonade/',
    alsfInstagram: 'https://www.instagram.com/AlexsLemonade/',
    ccdlBluesky: 'https://bsky.app/profile/cancerdatalab.bsky.social',
    ccdlTwitter: 'https://twitter.com/CancerDataLab',
    ccdlGithub: 'https://github.com/AlexsLemonade/',
    ccdlGithub_pipeline: 'https://github.com/AlexsLemonade/scpca-nf'
  },
  contact: {
    to: 'Alex’s Lemonade Stand Foundation for Childhood Cancer',
    address: '333 E. Lancaster Ave, #414, Wynnewood, PA 19096 USA',
    numbers: 'Phone: 866.333.1213 • Fax: 610.649.3038',
    email: 'scpca@ccdatalab.org'
  },
  termsOfUse
}

export default config
